export default "__VITE_ASSET__GaWJ0jLa__"